import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';
import { updateUserSkillNudgesCache } from './updateUserSkillNudgesCache';

const BULK_REJECT_USER_SKILL_NUDGE = gql`
  mutation bulkRejectUserSkillNudge($userUri: String!, $nudgeIds: [String!]!) {
    bulkRejectUserSkillNudge(userUri: $userUri, nudgeIds: $nudgeIds) {
      nudges {
        nudgeId
      }
      errors {
        nudge {
          nudgeId
        }
        error
      }
    }
  }
`;

const useBulkRejectUserSkillNudge = ({ userUri }) => {
  const [bulkRejectUserSkillNudgeMutation] = useMutation(
    BULK_REJECT_USER_SKILL_NUDGE,
    {}
  );

  const bulkRejectUserSkillNudge = useCallback(
    async nudgeIds => {
      return bulkRejectUserSkillNudgeMutation({
        variables: {
          userUri,
          nudgeIds
        },
        optimisticResponse: {
          bulkRejectUserSkillNudge: {
            nudges: nudgeIds.map(nudgeId => ({ nudgeId })),
            errors: [],
            __typename: 'UserSkillNudgesResponse'
          }
        },
        update: (cache, mutationResponse) =>
          updateUserSkillNudgesCache({
            cache,
            userUri,
            nudgeIds: mutationResponse.data?.bulkRejectUserSkillNudge.nudges.map(
              nudge => nudge.nudgeId
            )
          })
      });
    },
    [bulkRejectUserSkillNudgeMutation, userUri]
  );

  return { bulkRejectUserSkillNudge };
};

export default useBulkRejectUserSkillNudge;
